import createCRUDObservable from 'redux-observable-crud'
import { combineEpics } from 'redux-observable'
import BalanceActions, { BalanceRedux, BalanceTypes } from '../../Redux/ParentPlatform/BalanceRedux'

const balanceCRUDObservable = createCRUDObservable({
  mainRedux: BalanceRedux,
  reduxPath: 'parent_platform_balance',
  dataHandlers: {
    get: response => response.data,
  },
})

const getMoreBalanceEpic = (action$, store, { Api }) => (
  action$.ofType(BalanceTypes.getMoreRequest)
    .mergeMap(({ params }) => (
      Api.parent_platform_balance.get(params)
        .then(response => BalanceActions.getMoreSuccess(response.data))
        .catch(err => BalanceActions.getMoreError(err))
    ))
)

export const balanceObservers = Object.assign({}, balanceCRUDObservable.observers, {})


export const balanceEpic = combineEpics(
  balanceCRUDObservable.epic,
  getMoreBalanceEpic,
)



// WEBPACK FOOTER //
// ./src/Data/Observables/ParentPlatform/BalanceObservable.js